
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#D1D8E1","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.014 2.305a4.711 4.711 0 014.708 4.708 4.693 4.693 0 01-4.708 4.709 4.711 4.711 0 01-4.708-4.709 4.711 4.711 0 014.708-4.708zm0-1.723A6.42 6.42 0 00.583 7.013a6.42 6.42 0 006.431 6.431 6.42 6.42 0 006.431-6.43c0-3.561-2.9-6.432-6.431-6.432z"}}),_c('path',{attrs:{"d":"M7.904 3.195H6.18v4.766h1.723V3.195z"}})])
          )
        }
      }
    